// extracted by mini-css-extract-plugin
module.exports = {"tb-button-primary":"tb-button-primary","tb-button-secondary":"tb-button-secondary","tb-button-normal":"tb-button-normal","tb-button-small":"tb-button-small"};